// Pure helpers for the LogoAura canvas. Splitting the draw step out of the
// React effect keeps the component small and the render math testable.

export const PARTICLE_COUNT = 70;

export const createAuraParticles = (count = PARTICLE_COUNT) =>
  Array.from({ length: count }, () => ({
    angle: Math.random() * Math.PI * 2,
    radius: 30 + Math.random() * 110,
    speed: 0.0015 + Math.random() * 0.0025,
    size: Math.random() * 1.2 + 0.4,
    life: Math.random(),
    lifeSpeed: 0.0035 + Math.random() * 0.004,
    drift: 0.06 + Math.random() * 0.08,
  }));

const recycleParticle = (p) => {
  p.life = 0;
  p.radius = 28 + Math.random() * 30;
  p.angle = Math.random() * Math.PI * 2;
};

const drawBloom = (ctx, ox, oy, w) => {
  const bloom = ctx.createRadialGradient(ox, oy, 0, ox, oy, w * 0.4);
  bloom.addColorStop(0, "rgba(255, 235, 175, 0.10)");
  bloom.addColorStop(0.45, "rgba(212, 175, 55, 0.045)");
  bloom.addColorStop(1, "rgba(212, 175, 55, 0)");
  ctx.fillStyle = bloom;
  ctx.beginPath();
  ctx.arc(ox, oy, w * 0.4, 0, Math.PI * 2);
  ctx.fill();
};

const drawAuraParticle = (ctx, p, ox, oy) => {
  p.angle += p.speed;
  p.life += p.lifeSpeed;
  if (p.life > 1) recycleParticle(p);
  p.radius += p.drift;

  const x = ox + Math.cos(p.angle) * p.radius;
  const y = oy + Math.sin(p.angle) * p.radius;
  const alpha = (1 - p.life) * 0.85;
  const r = p.size * (0.7 + (1 - p.life) * 0.6);

  const halo = ctx.createRadialGradient(x, y, 0, x, y, r * 6);
  halo.addColorStop(0, `rgba(255, 232, 170, ${alpha * 0.7})`);
  halo.addColorStop(0.45, `rgba(212, 175, 55, ${alpha * 0.25})`);
  halo.addColorStop(1, "rgba(212, 175, 55, 0)");
  ctx.fillStyle = halo;
  ctx.beginPath();
  ctx.arc(x, y, r * 6, 0, Math.PI * 2);
  ctx.fill();

  ctx.beginPath();
  ctx.fillStyle = `rgba(255, 245, 215, ${alpha * 0.9})`;
  ctx.arc(x, y, r * 0.6, 0, Math.PI * 2);
  ctx.fill();
};

/**
 * Advance + render one frame of the logo aura. Mutates particle state.
 */
export const renderAuraFrame = (ctx, canvas, state, dpr) => {
  const w = canvas.width / dpr;
  const h = canvas.height / dpr;

  state.cur.x += (state.target.x - state.cur.x) * 0.04;
  state.cur.y += (state.target.y - state.cur.y) * 0.04;
  const ox = state.cur.x * w;
  const oy = state.cur.y * h;

  ctx.clearRect(0, 0, w, h);
  ctx.globalCompositeOperation = "lighter";

  drawBloom(ctx, ox, oy, w);
  for (const p of state.particles) drawAuraParticle(ctx, p, ox, oy);

  ctx.globalCompositeOperation = "source-over";
};
